// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.account-settings {
    max-width: var(--max-width-10xl, 120rem);
    margin: 0 auto;
    padding: 22px 24px 48px;
}`, "",{"version":3,"sources":["webpack://./src/pages/userSettings.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;IACxC,cAAc;IACd,uBAAuB;AAC3B","sourcesContent":[".account-settings {\r\n    max-width: var(--max-width-10xl, 120rem);\r\n    margin: 0 auto;\r\n    padding: 22px 24px 48px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
